import { Injectable } from '@angular/core';
import {
  CsvErrorSubmitResponse,
  CsvQueuedSubmitResponse,
  CsvSubmitResponse,
  CsvSuggestionsSubmitResponse
} from '../../../models/chat.model';
import { ChatCsvSubmitUiResult, ChatItem } from '../../../models/chat-ui.model';
import { ChatActionBuilderService } from '../presentation/chat-action-builder.service';
import { ChatMessageTextService } from '../presentation/chat-message-text.service';

@Injectable({
  providedIn: 'root'
})
export class ChatCsvUiMapperService {
  constructor(
    private actionBuilder: ChatActionBuilderService,
    private messageText: ChatMessageTextService
  ) {}

  buildStartMessages(query: string, filename: string, userEntityId: string, waitingEntityId: string): ChatItem[] {
    return [
      {
        type: 'user',
        content: query,
        timestamp: new Date(),
        entityId: userEntityId
      },
      {
        type: 'system',
        content: `Estamos esperando la respuesta del encolamiento de la tarea para el análisis del archivo "${filename}"...`,
        timestamp: new Date(),
        entityId: waitingEntityId
      }
    ];
  }

  mapSubmitResponse(response: CsvSubmitResponse, entityId: string): ChatCsvSubmitUiResult {
    if (response['status'] === 'queued') {
      return this.mapQueuedResponse(response as CsvQueuedSubmitResponse, entityId);
    }

    if (response['status'] === 'suggestions' && Array.isArray((response as CsvSuggestionsSubmitResponse).suggestions)) {
      return this.mapSuggestionsResponse(response as CsvSuggestionsSubmitResponse, entityId);
    }

    if (response['status'] === 'error') {
      return {
        kind: 'error',
        error: (response as CsvErrorSubmitResponse).message || 'Error en consulta CSV'
      };
    }

    return {
      kind: 'unexpected',
      message: {
        type: 'system',
        content: JSON.stringify(response),
        timestamp: new Date(),
        entityId
      }
    };
  }

  private mapQueuedResponse(response: CsvQueuedSubmitResponse, entityId: string): ChatCsvSubmitUiResult {
    const taskId = response.task_id || null;
    const msg = `Consulta encolada. Task ID: ${response.task_id}` +
      (response.document ? `, Documento: ${response.document}` : '');
    const message: ChatItem = {
      type: 'system',
      content: this.messageText.normalize(msg),
      timestamp: new Date(),
      entityId
    };

    if (taskId) {
      message.id = `task/${taskId}`;
      message.actions = [this.actionBuilder.buildTaskAction(taskId)];
    }

    return {
      kind: 'queued',
      message,
      taskId
    };
  }

  private mapSuggestionsResponse(response: CsvSuggestionsSubmitResponse, entityId: string): ChatCsvSubmitUiResult {
    const list = (response.suggestions || [])
      .map(suggestion => `${suggestion.nombre_documento} (ID: ${suggestion.id_documento})`)
      .join(', ');

    return {
      kind: 'suggestions',
      message: {
        type: 'system',
        content: `Sugerencias: ${list}`,
        timestamp: new Date(),
        entityId
      }
    };
  }
}
